export default __webpack_public_path__ + "static/img/21.07ff52e.png";